import { Component, OnInit } from '@angular/core';
import { style, state, animate, transition, trigger } from '@angular/animations';

// icons
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'empire-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  animations: [
    trigger('myAnimation', [
      transition(':enter', [
        style({ top: '-100vh' }),
        animate('500ms', style({ top: '0' }))
      ]),
      transition(':leave', [
        style({ top: '0' }),
        animate('500ms', style({ top: '-100vh' }))
      ])
    ])
  ]
})
export class HeaderComponent implements OnInit {

  email = faEnvelope;

  public isClassVisible;

  constructor() {
    this.isClassVisible = false;
  }

  ngOnInit() {
  }

}
